import React, { createContext, useState } from 'react';

import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

export const LearnToSwimStaffStateContext = createContext();

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const LearnToSwimStaffContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <LearnToSwimStaffStateContext.Provider value={stateHook}>
      {children}
    </LearnToSwimStaffStateContext.Provider>
  );
};

export default LearnToSwimStaffContextProvider;